/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-26 14:02:10
 */
import { createRef, useEffect, useState } from "react";
import { Menu, Input, Button, Form, message } from "antd";
import Video from "@root/components/video/index";
import { Header } from "./header/index";
import "./_style.scss";
import { getCourseLearnInfo, queryAddUserCommet } from "@root/common/service";
import { useSearchParams, useNavigate } from "react-router-dom";
import { setVideoInfo } from "@root/reducers/video";
import { useDispatch } from "react-redux";
import { getIPs, postLeaveAdvertisementTime } from "@root/common/utils";
import { RootState } from "@root/store/index";
import { useSelector } from "react-redux";
import { useForm } from "antd/lib/form/Form";
const { TextArea } = Input;
const items = [
  { label: "目录", key: "0" },
  { label: "讲师", key: "1" },
  { label: "评论", key: "2" },
];
interface SectionListProps {
  /**课件名称 */
  name: string;
  /**cc账号 */
  thirdAccount: string;
  /**视频Id */
  thirdVideoId: string;
  /**视频长度 */
  videoDurationText: string;
  /**观看时长 */
  videoWatchTimeText: string;
  /**学习进度 */
  videoWatchProgress: string;
}
interface TeacherListProps {
  /**教师姓名 */
  name: string;
  /**教师头像 */
  imageUrl: string;
  /**教师职称 */
  titleName: string;
  /**教师简介 */
  introduction: string;
}
export default function Play() {
  const [form] = useForm();
  const containerref = createRef<any>();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [current, setCurrent] = useState("0");
  const [videoInex, setVideoIndex] = useState(0);
  const [teacherList, setTeacherList] = useState<TeacherListProps[]>([]);
  const [sectionList, setSectionList] = useState<SectionListProps[]>([]);
  const courseId = Number(searchParams.get("courseId")) || 0;
  const navigate = useNavigate();
  const { instituteId, userId, access_token } = useSelector(
    (state: RootState) => state.userInfo
  );
  const { xy_video_bottom } = useSelector(
    (item: RootState) => item.advertisementData
  );
  const { name, vid } = useSelector((state: RootState) => state.videoInfo);
  const [ip, setIp] = useState("");
  const resetContainerHeight = () => {
    console.log(containerref.current);

    containerref.current.style.height =
      document.body.clientHeight - 70 - 74 + "px";
  };
  const queryCourseLearnInfo = async (videoInex: number) => {
    const {
      data: { courseSectionList = [], learnRuleInfo, teacherList = [] },
    } = await getCourseLearnInfo(courseId);
    const {
      thirdAccount,
      thirdVideoId,
      id,
      videoWatchTime,
      videoDuration,
      name,
    } = courseSectionList[videoInex];
    const {
      canDrag = 1,
      onHookTip,
      preventOnHook,
      randomPopUpNum,
    } = learnRuleInfo;
    setSectionList(courseSectionList);
    setTeacherList(teacherList);
    dispatch(
      setVideoInfo({
        rate_allow_change: !canDrag,
        progressbar_enable: canDrag === 1 ? 0 : 1,
        onHookTipInfo: onHookTip,
        preventOnHookFlag: preventOnHook,
        randomPopUpNum,
        vid: thirdVideoId,
        siteid: thirdAccount,
        courseId,
        sectionId: id,
        videoDuration,
        watchStartTime: videoWatchTime, //记录开始时间
        needRecord: true,
        name,
      })
    );
  };
  useEffect(() => {
    if (access_token) {
      resetContainerHeight();
      queryCourseLearnInfo(videoInex);
    }
  }, []);
  // 获取当前的ip
  useEffect(() => {
    access_token &&
      getIPs(function (ip: string) {
        setIp(ip);
      });
  }, []);
  useEffect(() => {
    if (!access_token) {
      navigate(`/login?courseId=${courseId}`);
    }
  }, []);
  /**
   * 提交用户评论
   * @param values
   */
  const addUserCommet = async (values: { content: String }) => {
    const { content } = values;
    if (!content) {
      message.info("请评论后再提交");
      return;
    }
    await queryAddUserCommet({
      subjectId: courseId,
      /**0视频,1病例 */
      subjectCategory: 0,
      subjectName: name,
      /**是否回复数据 */
      isRoot: "1",
      content,
      ip,
      instituteId,
      userId,
    });
    message.info("感谢您的反馈，我们将视情况与专家沟通并取得进一步指导意见。");
    form.setFieldsValue({
      content: "",
    });
  };
  useEffect(() => {
    if (access_token) {
      var startTime = new Date().valueOf() / 1000;
      return () => {
        postLeaveAdvertisementTime(xy_video_bottom, startTime);
      };
    }
  }, []);
  return (
    <div>
      <Header />
      <div className="videoList_container" ref={containerref}>
        <div className="live_container">
          <Video />
          {xy_video_bottom.length > 0 && (
            <img src={xy_video_bottom[0].imageUrl} alt="" height={"60px"} />
          )}
        </div>
        <div className="section_courseInfo">
          <Menu
            items={items}
            mode="horizontal"
            defaultSelectedKeys={[current]}
            onClick={(e) => {
              setCurrent(e.key);
            }}
          />
          {current === "0" && (
            <div className="sectionList_container">
              {sectionList.map((item, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    setVideoIndex(idx);
                    queryCourseLearnInfo(idx);
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <h3 className={videoInex === idx ? "current" : ""}>
                    {item.name}
                  </h3>
                  <p>
                    <span>视频时长：{item.videoDurationText}</span>
                    <span>学习进度：{item.videoWatchProgress}%</span>
                  </p>
                </div>
              ))}
            </div>
          )}
          {current === "1" &&
            teacherList.map((item, idx) => (
              <div className="sectionList_container" key={idx}>
                <div className="teacher_info">
                  <img
                    src={item.imageUrl}
                    alt=""
                    style={{
                      width: "70px",
                      borderRadius: "50%",
                    }}
                  />
                  <div className="teacher_name">
                    <h3>{item.name}</h3>
                    <p>{item.titleName}</p>
                  </div>
                </div>
                <p className="introduction">{item.introduction}</p>
              </div>
            ))}
          {current === "2" && (
            <Form
              name="basic"
              onFinish={addUserCommet}
              autoComplete="off"
              form={form}
            >
              <Form.Item name="content">
                <TextArea
                  style={{
                    height: "150px",
                    width: "280px",
                    padding: "4px 10px",
                  }}
                  maxLength={500}
                  showCount
                  placeholder="欢迎留言评论"
                />
              </Form.Item>
              <Form.Item
                style={{
                  textAlign: "right",
                  padding: "0 8px",
                }}
              >
                <Button type="primary" htmlType="submit">
                  提交
                </Button>
              </Form.Item>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
}
